/* import __COLOCATED_TEMPLATE__ from './active-invitation-content.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();